<app-layout-header></app-layout-header>
<main class="web-view">
    <router-outlet></router-outlet>
</main>
<app-layout-footer></app-layout-footer>
<app-layout-loader></app-layout-loader>
<app-layout-dialog></app-layout-dialog>